export const gameBrand = {
  name: "Tapu Savaşları",
  displayName: "TAPU SAVAŞLARI",
  compactName: "TAPU SAVAŞLARI · TÜRKİYE",
  subtitle: "Türkiye'nin Şehir Tapu Savaşı",
  slogan: "Şehrini seç, semti kap, kirayı topla!",
  domain: "tapusavaslari.com",

  getCityBrand: (cityId = 'izmir', lang = 'tr') => {
    const brands = {
      izmir: {
        title: lang === 'en' ? 'Izmir' : 'İzmir',
        subtitle: lang === 'en' ? 'Kordon Wars' : 'Kordon Savaşları',
        icon: '🌊',
        tagline: lang === 'en' ? 'Kordon Barons' : 'Kordon Ağaları'
      },
      istanbul: {
        title: lang === 'en' ? 'Istanbul' : 'İstanbul',
        subtitle: lang === 'en' ? 'Bosphorus Wars' : 'Boğaz Savaşları',
        icon: '🌉',
        tagline: lang === 'en' ? 'Bosphorus Barons' : 'Boğaz Ağaları'
      },
      ankara: {
        title: lang === 'en' ? 'Ankara' : 'Ankara',
        subtitle: lang === 'en' ? 'Çankaya Wars' : 'Çankaya Savaşları',
        icon: '🏛️',
        tagline: lang === 'en' ? 'Çankaya Barons' : 'Çankaya Ağaları'
      }
    };
    return brands[cityId] || brands.izmir;
  }
};
